import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PasswordPolicy} from '../models/password-policy.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';
import {getHttpParams} from '../helpers/request.helper';

@Injectable()
export class PasswordPolicyService {
    baseUrl = '/api/secured/password-policy';

    constructor(
        private http: HttpClient,
    ) {
    }

    getList() {
        const params = getHttpParams({
            orderByField: 'name'
        });
        return this.http.get<PasswordPolicy[]>(this.baseUrl, {params});
    }

    fetchList(props: SearchQueryParams) {
        return this.http
            .get<PasswordPolicy[]>(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<PasswordPolicy>(PasswordPolicy));
    }

    fetchById(policyId: number) {
        return this.http.get<PasswordPolicy>(`${this.baseUrl}/${policyId}`);
    }

    fetchForCurrentUser() {
        return this.http.get<PasswordPolicy>('/api/secured/user/password-policy');
    }

    add(passwordPolicy: PasswordPolicy) {
        return this.http.post(this.baseUrl, {...passwordPolicy});
    }

    delete(policyId: number) {
        return this.http.delete(`${this.baseUrl}/${policyId}`, {});
    }

    update(passwordPolicy: PasswordPolicy) {
        return this.http.put(`${this.baseUrl}/${passwordPolicy.id}`, {...passwordPolicy});
    }

}
